import { Callout } from '@/components/Callout'
import { Hero } from '@/components/Hero'
import { ProjectCard } from '@/components/ProjectCard'
import { laravelGraphqlEndpoint } from '@/globals/globals'
import { parseJSONinObject } from '@/lib/parseJSONinObject'
import { CarModel } from '@/types/car'
import { Project } from '@/types/project'
import { Box, Container, SimpleGrid } from '@chakra-ui/react'
import request, { gql } from 'graphql-request'
import { GetStaticPaths, GetStaticProps } from 'next'

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = await request(
    laravelGraphqlEndpoint,
    gql`
      {
        carModels {
          id_car_model
          memberProjects {
            published
            uuid
          }
        }
      }
    `
  )

  // check if we want to have a faster build
  const fullBuild = process.env.NEXT_BUILD_TYPE !== 'fast'

  return {
    paths: fullBuild
      ? paths.carModels
          .filter(
            (model: CarModel) =>
              model.memberProjects.filter(project => project.published).length >
              9
          )
          .map((model: CarModel) => {
            return {
              params: {
                id: model.id_car_model,
              },
            }
          })
      : [],
    fallback: 'blocking',
  }
}

export const getStaticProps: GetStaticProps = async ctx => {
  // Return 404 if no id is passed
  if (!ctx.params?.id) {
    return {
      notFound: true,
    }
  }

  const { carModelByID: modelsQuery } = await request(
    laravelGraphqlEndpoint,
    gql`
      query ($id: ID!) {
        carModelByID(id_car_model: $id) {
          name
          memberProjects {
            images
            published
            slug
            title
            uuid
          }
        }
      }
    `,
    { id: ctx.params.id }
  )

  const projects = modelsQuery.memberProjects
    .filter((project: Project) => project.published)
    .map((project: Project) => parseJSONinObject(project))

  return {
    props: {
      model: modelsQuery,
      projects,
    },
    revalidate: 60,
  }
}

export const Page = (props: { model: CarModel; projects: Project[] }) => {
  return (
    <>
      <Hero heading={`${props.model.name}`} />
      <Container maxWidth='8xl' py={20}>
        <SimpleGrid columns={[1, 2, 3]} spacing={8}>
          {props.projects.map((project: Project) => {
            return <ProjectCard key={project.slug} project={project} />
          })}
        </SimpleGrid>
        <Box pt={12} maxWidth='2xl' mx='auto'>
          <Callout title='Keep Browsing' href='/nation/categories' />
        </Box>
      </Container>
    </>
  )
}

export default Page
